export default __webpack_public_path__ + "static/media/hairun.38cee91c.jpg";